/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { LocalPricePointAllocation } from './LocalPricePointAllocation';
import {
    LocalPricePointAllocationFromJSON,
    LocalPricePointAllocationFromJSONTyped,
    LocalPricePointAllocationToJSON,
    LocalPricePointAllocationToJSONTyped,
} from './LocalPricePointAllocation';

/**
 * 
 * @export
 * @interface PricePointDto
 */
export interface PricePointDto {
    /**
     * 
     * @type {Array<LocalPricePointAllocation>}
     * @memberof PricePointDto
     */
    below?: Array<LocalPricePointAllocation> | null;
    /**
     * 
     * @type {Array<LocalPricePointAllocation>}
     * @memberof PricePointDto
     */
    above?: Array<LocalPricePointAllocation> | null;
}

/**
 * Check if a given object implements the PricePointDto interface.
 */
export function instanceOfPricePointDto(value: object): value is PricePointDto {
    return true;
}

export function PricePointDtoFromJSON(json: any): PricePointDto {
    return PricePointDtoFromJSONTyped(json, false);
}

export function PricePointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricePointDto {
    if (json == null) {
        return json;
    }
    return {
        
        'below': json['below'] == null ? undefined : ((json['below'] as Array<any>).map(LocalPricePointAllocationFromJSON)),
        'above': json['above'] == null ? undefined : ((json['above'] as Array<any>).map(LocalPricePointAllocationFromJSON)),
    };
}

export function PricePointDtoToJSON(json: any): PricePointDto {
    return PricePointDtoToJSONTyped(json, false);
}

export function PricePointDtoToJSONTyped(value?: PricePointDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'below': value['below'] == null ? undefined : ((value['below'] as Array<any>).map(LocalPricePointAllocationToJSON)),
        'above': value['above'] == null ? undefined : ((value['above'] as Array<any>).map(LocalPricePointAllocationToJSON)),
    };
}

